<div class="fetch" [hidden]="loading">
  <div class="employee-details-header">
    <div class="primary-header d-flex">
      <span>Vehicle and Employee Details</span>
      <img
        class="close-icon"
        [src]="ASSETS_PATH_CONST.CANCEL_ICON"
        alt=""
        (click)="closeModal()"
      />
    </div>
    <div class="secondary-header">
      Trip ID: {{ tripDetails?.tripId }} Office: {{ getOfficeAddress() }}
    </div>
  </div>

  <div class="vehicle-details">
    <div class="vehicle right-bar">

      <span class="vehilce-icon">
        <img [src]="getVehicleImage()" alt="">
      </span>

      <span [innerHTML]="SVG_CONSTANTS.DOT_SEPARATOR | sanitizeHtml"></span>

      <span class="vehicle-registration-number"> {{tripDetails?.vehicle?.vehicleIdentification}} </span>

      <span [innerHTML]="SVG_CONSTANTS.DOT_SEPARATOR | sanitizeHtml"></span>

      <span class="vehicle-name">  {{tripDetails?.vehicle?.vehicleType?.name}} </span>

      <span [innerHTML]="SVG_CONSTANTS.DOT_SEPARATOR | sanitizeHtml"></span>

      <span class="vehicle-id">  {{tripDetails?.vehicle?.vehicleId}}  </span>

      <span [innerHTML]="SVG_CONSTANTS.DOT_SEPARATOR | sanitizeHtml"></span>

      <span class="vehicle-type"> {{tripDetails?.vehicle?.vehicleType?.maxCapacity}}  </span>
    </div>

    <div class="driver right-bar">
      <span class="driver-name">{{ tripDetails?.driver?.name }}</span>
      <span class="phone-icon">
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8772 15C9.79874 15 5.66663 10.8679 5.66663 5.78947C5.66663 5.3542 6.02083 5 6.45609 5H8.29821C8.73349 5 9.08769 5.3542 9.08769 5.78947C9.08769 6.40527 9.18453 7.01 9.37506 7.58632C9.46506 7.8742 9.38979 8.18158 9.17979 8.39158L8.34559 9.5C9.03136 10.7932 9.86506 11.6263 11.1677 12.3216L12.3029 11.4642C12.432 11.3325 12.6271 11.2568 12.8287 11.2568C12.9139 11.2568 13.0004 11.2703 13.0835 11.299C13.6561 11.4879 14.2603 11.5842 14.8772 11.5842C15.3124 11.5842 15.6666 11.9384 15.6666 12.3737V14.2105C15.6666 14.6458 15.3124 15 14.8772 15Z"
            fill="#181F33"
          />
        </svg>
      </span>
      <span class="phone-number">{{ tripDetails?.driver?.phoneNumber }}</span>
    </div>

    <div class="shift-details">
      <span class="shift">Shift:</span>
      <span class="shift-value">{{
        getShiftDetails(tripDetails?.shift?.date)
      }}</span>
    </div>

    <div class="marshall-details" *ngIf="tripDetails?.ismarshalRequired">
      <span [innerHTML]="SVG_CONSTANTS.DOT_SEPARATOR | sanitizeHtml"></span>
      <span class="marshall-icon">
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8076 5.18095L9.20902 2.76486C9.01581 2.68154 8.8075 2.66406 8.66682 2.66406C8.5261 2.66406 8.3178 2.68156 8.12449 2.76492L2.52595 5.18095C2.11735 5.35732 1.90462 5.84047 2.0416 6.28094L3.01404 9.40697V9.57322C3.01404 10.5304 3.01404 11.5201 3.80463 12.2483C4.61737 12.9969 6.11693 13.3307 8.66682 13.3307C11.2167 13.3307 12.7162 12.9969 13.529 12.2483C14.3195 11.5201 14.3195 10.5304 14.3195 9.57322V9.40697L15.292 6.28089C15.429 5.84041 15.2162 5.35727 14.8076 5.18095ZM14.5493 6.02694L13.6455 8.93232H3.68805L2.78428 6.02694C2.77506 5.99738 2.79586 5.9502 2.82328 5.93837L8.42169 3.52237C8.4657 3.5034 8.55318 3.48311 8.66682 3.48311C8.78042 3.48311 8.86791 3.5034 8.91182 3.52232L14.5103 5.93835C14.5377 5.9502 14.5585 5.9974 14.5493 6.02694Z"
            fill="#B00020"
          />
          <path
            d="M8.66646 5.86927L7.33313 5.33594V7.29149L8.66646 8.0026L9.9998 7.29149V5.33594L8.66646 5.86927Z"
            fill="#B00020"
          />
        </svg>
      </span>
      <span class="marshall-text">Marshall Required</span>
    </div>
  </div>

  <div class="chips-container" *ngIf="!data['data']['showUnknownRFID']">
    <app-chips-selector
      [chips]="items"
      (selectedChips)="onSelectionChange($event)"
    >
    </app-chips-selector>
  </div>
  <div class="unknown-rfid-swipes"  *ngIf="data['data']['showUnknownRFID']">
    Unknown RFID tags swipes
  </div>

  <div class="table-info-section">
    <div class="table-paginator">
      <div class="app-table-wrapper">
        <table mat-table [dataSource]="dataSource" matSort class="mis-table">
          <ng-container *ngFor="let column of columns">
            <ng-container
              [matColumnDef]="column.matColumnDef"
              [sticky]="column.sticky"
              [stickyEnd]="column.stickyEnd"
            >
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ column.headerText }}
              </th>
              <td mat-cell *matCellDef="let element">
                <div
                  *ngIf="column.type == 'TEXT'"
                  [text]="column.showTooltip && element[column.matColumnDef]"
                  class="truncate"
                  misToolTip
                >
                  {{ element[column.matColumnDef] || '--' }}
                </div>
                <div
                  *ngIf="column.type == 'GENDER'"
                  class="truncate"
                >
                  <span misToolTip [text]="element[column.matColumnDef]">
                    <img [src]="getGenderIcon(element[column.matColumnDef])" alt="">
                  </span>
                </div>
                <div
                  *ngIf="column.type == 'STATUS'"
                  [title]="element[column.matColumnDef]"
                  class="truncate status-text"
                  [ngClass]="{
                    'no-show': element[column.matColumnDef] === 'NO SHOW',
                    'yet-to-board':
                      element[column.matColumnDef] === 'YET TO BOARD' || 
                      element[column.matColumnDef] === 'ORPHAN',
                    boarded: element[column.matColumnDef] === 'BOARDED',
                    'ad-hoc': element[column.matColumnDef] === 'AD-HOC' || element[column.matColumnDef] === 'UNMAPPED'
                  }"
                >
                  {{ element[column.matColumnDef] }}
                </div>
                <div *ngIf="column.type == 'TIME' && !signInFields.includes(column.matColumnDef)" class="truncate">
                  <span *ngIf="!element[column.matColumnDef];else elseblock">
                     {{ '--:--'}}
                  </span>
                  <ng-template #elseblock>
                    {{ element[column.matColumnDef] | date : "mediumTime" }}
                  </ng-template>
                </div>
                <div *ngIf="column.type == 'TIME' && signInFields.includes(column.matColumnDef)" class="truncate">
                  {{ getSignInTimes(element,column.matColumnDef) }}
                </div>
              </td>
            </ng-container>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div class="pagination-container" *ngIf="dataSource.data.length > 10">
        <mat-paginator
          [pageSizeOptions]="[15, 20, 50]"
          showFirstLastButtons
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
    </div>
  </div>

  <div class="d-flex flex-dir-col mt-10" *ngIf="!data['data']['showUnknownRFID']">
    <span class="h7"
      ><sup>*</sup>Time when driver reported at employee's pickup place. This is
      updated on trip completion.</span
    >
    <span class="h7"
      ><sup>**</sup>Distance traveled by employee from the start point.</span
    >
  </div>
</div>
